import { doGet, doUpdateUserProfile } from './common';
import env from 'utils/env';
import { getItem } from 'utils/local-storage';
import { ACCESS_TOKEN } from 'utils/storage-keys';

export async function updateUserApi(
  username: string,
  password: string,
  new_password: string,
  phone: string,
  date_of_birth: string,
  address: string
) {
  const config = env();
  const url = `${config.userServerApiUrl}/user/api/v1/account`;
  return doUpdateUserProfile(
    url,
    {
      username,
      password,
      new_password,
      phone,
      date_of_birth,
      address
    },
    {
      'X-Session-Token': getItem(ACCESS_TOKEN)
    }
  );
}

export async function getUserProfile(accessToken: string | null) {
  const url = `user/api/v1/account`;
  if (accessToken) {
    return doGet<any, any>(
      url,
      {},
      {
        'X-Session-Token': accessToken
      }
    );
  }
}

export async function getUserTier(accessToken: string | null) {
  const url = `entitlement/api/v1/user/entitlements?encrypt=false`;
  if (accessToken) {
    return doGet<any, any>(
      url,
      {},
      {
        'X-Session-Token': accessToken
      }
    );
  }
}
